import React, { useEffect, useRef, useState } from 'react';

// Extracts a TikTok video ID from a variety of URL shapes
export function parseTikTok(url) {
  if (!url) return null;
  const m = url.match(/\/video\/(\d+)/);
  if (m) return { id: m[1], url };
  // /t/xxxxx short links can be embedded by URL only
  return { id: null, url };
}

/**
 * Official TikTok embed (blockquote + embed.js).
 * Loads TikTok's script once and lets it hydrate any blockquote on the page.
 */
export default function TikTokEmbed({ url, title }) {
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const info = parseTikTok(url);

  useEffect(() => {
    if (!info) return;
    // Load TikTok embed script once (idempotent)
    const src = 'https://www.tiktok.com/embed.js';
    let script = document.querySelector(`script[src="${src}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }
    // If script already loaded before, call reload if TikTok exposes it
    const t = setTimeout(() => {
      if (window.tiktokEmbedLoad) {
        try {
          window.tiktokEmbedLoad();
        } catch (e) {}
      }
      setLoaded(true);
    }, 800);
    return () => clearTimeout(t);
  }, [info?.id, info?.url]);

  if (!info) return null;

  return (
    <div ref={containerRef} className="tiktok-embed-wrapper w-full">
      <blockquote
        className="tiktok-embed"
        cite={info.url}
        data-video-id={info.id || ''}
        style={{ maxWidth: '605px', minWidth: '280px', margin: 0 }}
      >
        <section>
          <a href={info.url} target="_blank" rel="noopener noreferrer">
            {title || 'View on TikTok'}
          </a>
        </section>
      </blockquote>
      {!loaded && (
        <div className="aspect-[9/16] bg-slate-100 animate-pulse rounded-md flex items-center justify-center text-slate-400 text-xs">
          Loading TikTok…
        </div>
      )}
    </div>
  );
}
